export const columHeader = {
    "1": [
        "ID", "巡回ルート名", "巡回回数", "区分", "事業所", "路線番号", "現旧区分", "路線枝番",
        { title: "区間起点", colspan: 2, subTitles: ["緯度", "経度"] },
        { title: "区間終点", colspan: 2, subTitles: ["緯度", "経度"] },
        "区間起点距離標", "区間終点距離標", "上下区分", "道路区分", "車線", "時点", "巡回種類", "巡回実施延長km", "備考", "更新アカウント", "更新日時"
      ],
    "2": [
        "ID", "事業所", "路線番号", "現旧区分", "路線枝番",
        { title: "位置起点", colspan: 2, subTitles: ["緯度", "経度"] },
        { title: "位置終点", colspan: 2, subTitles: ["緯度", "経度"] },
        "位置起点距離標", "位置終点距離標", "上下区分", "道路区分", "車線", "地先", "発見日", "処理日", "事象中内訳", "事象内訳","施設名", "事象の状況", "処理作業の有無", "処理作業の内容", "巡回ID", "更新アカウント", "更新日時"
      ],
    "3":[
        "ID", "事業所", "路線番号", "現旧区分", "路線枝番",
        { title: "位置起点", colspan: 2, subTitles: ["緯度", "経度"] },
        { title: "位置終点", colspan: 2, subTitles: ["緯度", "経度"] },
        "位置起点距離標", "位置終点距離標", "上下区分", "道路区分", "車線", "地先", "時点", "道路緊急ダイヤルの該当", "相手方区分",
        "意見・要望の種類及び内訳", "その他", "現地対応の有無", "現地対応の具体的な内容", "案件番号", "更新アカウント", "更新日時"
    ],
    "4":[
        "ID", "事業所", "路線番号", "現旧区分", "路線枝番",
        { title: "位置起点", colspan: 2, subTitles: ["緯度", "経度"] },
        { title: "位置終点", colspan: 2, subTitles: ["緯度", "経度"] },
        "位置起点距離標", "位置終点距離標", "上下区分", "道路区分", "車線", "地先", "時点", "作業項目", "清掃実施延長（km）",

        "塵埃回収量（m3）", "排水構造物清掃実施延長_管路", "排水構造物清掃実施箇所_桝", "案件番号", "更新アカウント", "更新日時"
    ],
    "5":[
        "ID", "事業所", "路線番号", "現旧区分", "路線枝番",
        { title: "位置起点", colspan: 2, subTitles: ["緯度", "経度"] },
        { title: "位置終点", colspan: 2, subTitles: ["緯度", "経度"] },
        "位置起点距離標", "位置終点距離標", "上下区分", "道路区分", "車線", "地先", "冠水発生日時", "路面清掃の頻度［回/年］",
        "排水構造物清掃（直近実施年月）", "冠水発生時の降雨量_1時間雨量[mm/h]", "冠水発生時の降雨量_10分間雨量[mm/10min]", "最寄りの気象庁観測所名", "冠水発生の原因", "「その他」の場合、具体的な要因を記入", "詰まりの程度",
        "詰まりの原因", "冠水発生後の処理_清掃の有無", "清掃実施箇所", "清掃実施箇所（その他記入）", "冠水危険箇所", "更新アカウント", "更新日時"
    ],
    "6":[
        "ID", "事業所", "路線番号", "現旧区分", "路線枝番",
        { title: "位置起点", colspan: 2, subTitles: ["緯度", "経度"] },
        { title: "位置終点", colspan: 2, subTitles: ["緯度", "経度"] },
        "位置起点距離標", "位置終点距離標", "上下区分", "道路区分", "車線", "地先", "時点", "除草実施面積（m2）",
        "対応区分", "処分量（t）", "案件番号", "更新アカウント", "更新日時"
    ],
};

export const responseParm = {
  REQUEST_RESPONSE_0 : 0,
  REQUEST_RESPONSE_1 : 1,
  REQUEST_CODE_200 : "200",
  REQUEST_CODE_400 : "400",
  REQUEST_CODE_401 : "401",
  REQUEST_CODE_403 : "403",
  REQUEST_CODE_500 : "500",
};

export const fileName = {
  REGISTER_COUNT_PATROL:"registerCount_patrol_",
  REGISTER_COUNT_PROCESSING:"registerCount_processing_",
  REGISTER_COUNT_OPINION_REQUESTS:"registerCount_opinions_",
  REGISTER_COUNT_CLEANING: "registerCount_cleaning_",
  REGISTER_COUNT_FLOODING: "registerCount_flooding_",
  REGISTER_COUNT_WEEDING: "registerCount_weeding_",
  OUTPUT_PATROL:"patrol_",
  OUTPUT_PROCESSING:"processing_",
  OUTPUT_OPINIONS:"opinions_",
  OUTPUT_CLEANING:"cleaning_",
  OUTPUT_FLOODING:"flooding_",
  OUTPUT_WEEDING:"weeding_",
};

export const responseMessage = {
  WORK_TYPE_ERROR : "作業項目は必須項目です。",
};

export const requestParm = {
  REQUEST_PAGE : 1,
  ORDER_CATEGORY: [
    { code: "0", SortOrderCategoryName: "昇順" },
    { code: "1", SortOrderCategoryName: "降順" },
  ],
  COMMON_FLAG_FALSE: "0",
  COMMON_FLAG_TRUE: "1",
  WORK_TYPE_1 : "1",
  WORK_TYPE_2 : "2",
  WORK_TYPE_3 : "3",
  WORK_TYPE_4 : "4",
  WORK_TYPE_5 : "5",
  WORK_TYPE_6 : "6",
  OUTPUT_CSV :"CSV",
  OUTPUT_GEOJSON: "GeoJSON",
  NUMBER_OF_SEARCHES: 0,
  DISPLAY_START_NUMBER:0,
  DISPLAY_END_NUMBER:0,
  PAGE_0:0,
  PAGE_1:1,
  DISPLAY_RESULT:50,
  DEFAULT_DISPLAY:"50",
};
